// RadarChart.js
import React from "react";
import ReactECharts from "echarts-for-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const MAX_VALUE = 105;

const GraphSangatiRight = ({
  height = "280px",
  isdarkdisabled,
  showCompatibility,
  darkData = {},
  matcheedarkdata = {},
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const UserDarkData = isdarkdisabled
    ? [0, 0, 0, 0, 0, 0, 0, 0]
    : [
        darkData.extraversion || 0,
        1000,
        1000,
        1000,
        darkData.stability || 0,
        darkData.rule_abiding || 0,
        darkData.comfort_zone || 0,
        darkData.agreeableness || 0,
      ];

  const MatcheeDarkData = [
    matcheedarkdata.extraversion || 0,
    1000,
    1000,
    1000,
    matcheedarkdata.stability || 0,
    matcheedarkdata.rule_abiding || 0,
    matcheedarkdata.comfort_zone || 0,
    matcheedarkdata.agreeableness || 0,
  ];

  const option = {
    tooltip: { show: false },
    radar: {
      center: ["0.5%", "50%"],
      splitArea: {
        show: false,
      },
      splitLine: {
        show: false,
      },
      radius: window.innerWidth < 768 ? "140%" : "80%",
      lineStyle: {
        color: "#ffffff",
      },
      axisLine: {
        lineStyle: {
          width: 3,
          color: "white",
        },
      },
      name: {
        formatter: (name) => {
          if (name === t("extraversionShortForm")) {
            return `{ext|${name}}`;
          } else if (name === t("stabilityShortForm")) {
            return `{st|${name}}`;
          } else if (name === t("comfortZoneShortForm")) {
            return `{cz|${name}}`;
          } else if (name === t("ruleAbidingShortForm")) {
            return `{ra|${name}}`;
          } else if (name === t("agreeablenessShortForm")) {
            return `{ag|${name}}`;
          }
          return name;
        },
        rich: {
          ext: {
            padding: [0, 0, -10, 30],
            color: "#fff",
            fontSize: 12,
          },
          st: {
            padding: [-10, 0, 0, 30],
            color: "#fff",
            fontSize: 12,
          },
          cz: {
            padding: [5, 0, 0, -5],
            color: "#fff",
            fontSize: 12,
          },
          ra: {
            padding: [0, -10, 0, -5],
            color: "#fff",
            fontSize: 12,
          },
          ag: {
            padding: [0, 0, 0, -5],
            color: "#fff",
            fontSize: 12,
          },
        },
        textStyle: {
          fontSize: 12,
          color: "#fff",
        },
      },
      indicator: [
        { name: t("extraversionShortForm"), max: MAX_VALUE }, // top
        //
        { name: "", max: MAX_VALUE },
        { name: "", max: MAX_VALUE },
        { name: "", max: MAX_VALUE },
        //
        { name: t("stabilityShortForm"), max: MAX_VALUE },
        { name: t("ruleAbidingShortForm"), max: MAX_VALUE },
        { name: t("comfortZoneShortForm"), max: MAX_VALUE },
        { name: t("agreeablenessShortForm"), max: MAX_VALUE },
      ],
    },
    series: [
      {
        type: "radar",
        lineStyle: {
          color: "#93938D",
        },
        data: [
          {
            value: UserDarkData,
            // Users main graph style (light blue, filled, opacity 0.95)
            areaStyle: {
              color: "#FFE279",
              opacity: 0.95,
            },
            // Users circle style (light blue, circle with black border)
            symbol: "circle",
            symbolSize: 4,
            itemStyle: {
              color: "#BEEDF3",
              borderColor: "#000000",
              borderWidth: 1,
            },
            emphasis: { disabled: true },
          },
          ...(showCompatibility && !isdarkdisabled
            ? [
                {
                  value: MatcheeDarkData,
                  // Matchee main graph style (light pink, filled, opacity 0.95)
                  areaStyle: {
                    color: "#FBEAEA",
                    opacity: 0.70,
                  },
                  // Matchee circle style (light pink, rect with black border)
                  symbol: "rect",
                  symbolSize: 4,
                  itemStyle: {
                    color: "#F2B8B8",
                    borderColor: "#000000",
                    borderWidth: 1.5,
                  },
                  emphasis: { disabled: true },
                },
              ]
            : []),
        ],
      },
    ],
  };

  return (
    <div className="relative h-full w-full overflow-hidden px-1"
      onClick={() => {
        if (!isdarkdisabled) {
          navigate("/graph-details-dark", {
            state: { showCompatibility, UserDarkData, MatcheeDarkData },
          });
        }
      }}
    >
      <ReactECharts
        option={option}
        style={{ width: "100%", height: height }}
        notMerge={true}
        lazyUpdate={true}
      />

      <div
        className="absolute -bottom-1 right-3"
      >
        <img src="/icons/Sangati/rightarrow.svg" alt="" className="w-8 h-8" />
      </div>
    </div>
  );
};

export default GraphSangatiRight;
